/**
 * useSaveCountdown - Countdown timer for auto-navigate after save
 */
import { useState, useEffect, Dispatch, SetStateAction } from 'react'
import { useNavigate } from 'react-router-dom'
import type { EditorModalState } from '../types'

interface UseSaveCountdownParams {
  modalState: EditorModalState
  setModalState: Dispatch<SetStateAction<EditorModalState>>
  autoNavigate: boolean
  urlProjectId: string | undefined
}

export function useSaveCountdown({
  modalState,
  setModalState,
  autoNavigate,
  urlProjectId,
}: UseSaveCountdownParams) {
  const navigate = useNavigate()
  const [saveCountdown, setSaveCountdown] = useState(3)

  useEffect(() => {
    if (modalState.save && autoNavigate && saveCountdown > 0) {
      const timer = setTimeout(() => {
        setSaveCountdown(saveCountdown - 1)
      }, 1000)
      return () => clearTimeout(timer)
    } else if (modalState.save && autoNavigate && saveCountdown === 0) {
      setModalState((prev) => ({ ...prev, save: false }))
      navigate(`/project/${urlProjectId}/map-editor`)
    }
  }, [modalState.save, autoNavigate, saveCountdown, navigate, setModalState, urlProjectId])

  return { saveCountdown, setSaveCountdown }
}
